// extracted by mini-css-extract-plugin
module.exports = {"container":"video-module--container--21I_2","video":"video-module--video--1s_MC"};